module.exports = __webpack_public_path__ + "img/lanli-logo-dark.0ac91da4.png";